import React from "react";
import Link from "next/link";
import { HiArrowLongRight } from "react-icons/hi2";
import styles from "./buttons.module.css";

const ButtonPrimary = ({
  buttonText,
  buttonUrl,
  icon = <HiArrowLongRight />,
  borderShadow = true,
  newTab = false,
  bgColor = "bg-violet-500",
}) => {
  return (
    <Link
      href={`${buttonUrl}`}
      target={newTab ? "_blank" : "_self"}
      className={`w-fit flex items-center justify-center gap-2 px-5 py-[12px] text-lg text-white ${bgColor} rounded-md ${
        borderShadow ? styles.buttonPrimary : "hover:bg-violet-500/90"
      }`}
    >
      <span className="">{buttonText}</span>
      {icon && <span className="text-2xl">{icon}</span>}
    </Link>
  );
};

const ButtonSecondary = ({ buttonText, buttonUrl, icon, newTab = false }) => {
  return (
    <Link
      href={`${buttonUrl}`}
      scroll={false}
      target={newTab ? "_blank" : "_self"}
      className="w-fit flex items-center justify-center gap-2 px-6 py-[12px] bg-white hover:bg-violet-500 text-lg text-gray-900 hover:text-white border border-gray-600 hover:border-violet-500 rounded-md transition-all duration-300 ease-in-out"
    >
      <span onClick={(e) => e.stopPropagation()} className="">
        {buttonText}
      </span>
      {icon && (
        <span onClick={(e) => e.stopPropagation()} className="text-2xl">
          {icon}
        </span>
      )}
    </Link>
  );
};

const RoundButton = ({
  buttonText,
  buttonUrl,
  icon,
  newTab = false,
  fullWidth = true,
  transparent = true,
}) => {
  return (
    <Link
      href={`${buttonUrl}`}
      target={newTab ? "_blank" : "_self"}
      className={`${
        fullWidth ? "w-full" : "w-fit"
      } flex items-center justify-center px-6 py-[12px] ${
        transparent
          ? "bg-transparent text-black hover:bg-black hover:text-[#fff]"
          : "text-[#fff] bg-black"
      }  text-xl text-gray-900 border border-gray-800 rounded-full transition-all duration-300 ease-in-out`}
    >
      <span onClick={(e) => e.stopPropagation()} className="">
        {buttonText}
      </span>
      {icon && (
        <span onClick={(e) => e.stopPropagation()} className="text-xl">
          {icon}
        </span>
      )}
    </Link>
  );
};

const RoundButtonDiv = ({
  buttonText,
  icon,
  onclick,
  fullWidth = true,
  transparent = true,
}) => {
  return (
    <div
      onClick={() => {
        if (onclick) onclick();
      }}
      className={`${
        fullWidth ? "w-full" : "w-fit"
      } cursor-pointer flex items-center justify-center px-6 py-[12px] ${
        transparent
          ? "bg-transparent text-black hover:bg-black hover:text-[#fff]"
          : "text-[#fff] bg-black"
      }  text-xl text-gray-900 border border-gray-800 rounded-full transition-all duration-300 ease-in-out`}
    >
      <span className="">{buttonText}</span>
      {icon && <span className="text-xl">{icon}</span>}
    </div>
  );
};

const ButtonSecondaryDiv = ({
  buttonText,
  icon,
  onclick,
  isFullWidth = true,
  textClassName,
}) => {
  return (
    <div
      onClick={() => onclick && onclick()}
      className={`${
        isFullWidth ? "w-full" : "w-fit"
      } cursor-pointer flex items-center justify-center gap-2 px-6 py-[12px] bg-white hover:bg-violet-500 text-lg text-gray-900 hover:text-white border border-gray-600 hover:border-white rounded-md transition-all duration-300 ease-in-out`}
    >
      {icon && <span className="text-2xl">{icon}</span>}
      <span className={`${textClassName}`}>{buttonText}</span>
    </div>
  );
};

const ButtonPrimaryDiv = ({
  buttonText,
  onclick,
  icon = <HiArrowLongRight />,
  borderShadow = true,
  bgColor = "bg-violet-500",
}) => {
  return (
    <div
      onClick={() => {
        if (onclick) onclick();
      }}
      className={`w-fit cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 px-5 py-[12px] text-lg text-white ${bgColor} rounded-md ${
        borderShadow ? styles.buttonPrimary : "hover:bg-violet-500/90"
      }`}
    >
      <span className="whitespace-nowrap">{buttonText}</span>
      {icon && <span className="text-2xl">{icon}</span>}
    </div>
  );
};

export {
  ButtonPrimary,
  ButtonSecondary,
  ButtonSecondaryDiv,
  RoundButton,
  RoundButtonDiv,
  ButtonPrimaryDiv,
};
